import LabledField from './component'

export default LabledField
